/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaBlocFormViewProps } from './citta-bloc-form';

/**
 *
 * ICittaProductSkuView component
 * @extends {React.PureComponent<ICittaProductSkuViewProps>}
 */
export class ICittaCompetitionFormView extends React.PureComponent<ICittaBlocFormViewProps> {

    public render(): JSX.Element | null {
        const { SubscribeWrapper, subscribeResponse, subscribeForm, responseSuccess, showResponseSuccess, formErrors, formErrorsNodeProps, successResponseNodeProps, showSuccessResponse, successResponse } = this.props;
        const { 
            FormWrapper,
            FormContainer,
            firstAndLastNameInput,
            emailInput,
            storeInput,
            phoneInput,
            subscribeButtton,
            reCaptcha,
            subscribeThanks
        } = subscribeForm;
        return (
            <Module {...SubscribeWrapper} >
                {subscribeResponse}
                {showSuccessResponse ?
                    <Node {...successResponseNodeProps}>
                        {successResponse}
                    </Node>
                    : <Node {...FormWrapper} >
                        <Node {...FormContainer} >
                            {firstAndLastNameInput}
                            {emailInput}
                            {storeInput}
                            {phoneInput}
                            {reCaptcha}
                            {responseSuccess && showResponseSuccess ? subscribeThanks : subscribeButtton}
                        </Node>
                        <Node {...formErrorsNodeProps}>
                            {formErrors}
                        </Node>
                    </Node>
                }
            </Module>
        );
    }
}
export default ICittaCompetitionFormView;
